import { w as win } from "../chunks/common-namespaces-client-DXKc2YAH.mjs";
function defineFunction(handler) {
  return handler;
}
function defineEvent(...listeners) {
  return { [Symbol.onexus.event]: listeners };
}
const createEventTopic = defineEvent;
function defineNamespace(implementation) {
  return { ...implementation, [Symbol.onexus.namespace]: true };
}
const otto = win.otto ?? {};
export {
  createEventTopic,
  defineEvent,
  defineFunction,
  defineNamespace,
  otto
};
/*                                     */
